export default class {
  constructor (el) {
    this.el = el
    this.label = el.querySelector('.js-select-label')
    this.list = el.querySelector('.js-select-list')
    this.isFilter = el.classList.contains('js-filter')
    this.field = el.querySelector('.js-select-field')

    window.addEventListener('click', this.handleClick.bind(this))
    window.addEventListener('focus', this.handleWindowFocus.bind(this), true)
  }

  handleClick (e) {
    if (!e.target) return

    if (e.target.closest('.js-select') !== this.el) {
      this.close()
      return
    }

    if (e.target.closest('.js-select-label')) {
      this.toggle()
      return
    }

    if (e.target.closest('.js-select-option')) {
      this.label.firstElementChild.textContent = e.target.closest('.js-select-option').textContent
      if (this.field) {
        this.field.value = e.target.closest('.js-select-option').getAttribute('data-value')
      }
      this.label.classList.remove('select__label--placeholder')
      this.label.classList.remove('filter__label--placeholder')
      this.close()
    }
  }

  handleWindowFocus (e) {
    if (!e.target || e.target === window || e.target === document) return
    if (!e.target.closest('.js-select')) this.close()
  }

  open () {
    if (this.isFilter) {
      const labelWidth = this.label.offsetWidth
      const listWidth = this.list.offsetWidth

      if (labelWidth < listWidth) {
        this.label.style.width = `${this.list.offsetWidth}px`
      } else {
        this.list.style.width = `${this.label.offsetWidth}px`
      }
    }

    this.el.classList.add('is-active')
  }

  close () {
    if (this.isFilter) {
      this.label.style.width = ''
    }

    this.el.classList.remove('is-active')
  }

  toggle () {
    if (this.el.classList.contains('is-active')) {
      this.close()
    } else {
      this.open()
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_select.js